import {
  GetAllWarehouses,
  GetAllWarehousesPayload,
} from "../../services/warehouses/get-all/types";

export const fetchAllWarehouses =
  (response: GetAllWarehouses[]) => async (dispatch: any) => {
    try {
      dispatch({ type: "FETCH_ALL_WAREHOUSES_SUCCESS", payload: response });
    } catch (error) {
      console.log("error fetchAllWarehouses", error);
    }
  };
